/* Rivacco – fügt dem Countdown "Rabattpreis endet bald" im Warenkorb Sekunden hinzu */
(function(){
  function p(n){return (n<10?'0':'')+n}
  function endFrom(txt){
    var d=/(\d+)\s*TAGE?/.exec(txt), h=/(\d+)\s*STD/.exec(txt), m=/(\d+)\s*MIN/.exec(txt);
    if(!d&&!h&&!m) return 0;
    var now=Date.now(), off=(function(){try{var x=new Date();return Math.round((new Date(x.toLocaleString('en-US',{timeZone:'Europe/Berlin'}))-new Date(x.toLocaleString('en-US',{timeZone:'UTC'})))/60000)}catch(e){return 120}})()*60000, tr=new Date(now+off);
    var base=Date.UTC(tr.getUTCFullYear(),tr.getUTCMonth(),tr.getUTCDate(),23,59,59)-off;
    for(var k=0;k<15;k++){
      var T=base+k*86400000, left=T-now; if(left<=0) continue;
      var H=Math.floor(left/3600000), M=Math.floor(left%3600000/60000);
      if(d && !h){ if(Math.floor(H/24)===+d[1]) return T; continue; }
      var wantH=(d?+d[1]*24:0)+(h?+h[1]:0), wantM=m?+m[1]:0;
      if(H===wantH && Math.abs(M-wantM)<=1) return T;
    }
    return 0;
  }
  function tick(){
    var als=document.querySelectorAll('.rv-cd-alert');
    for(var i=0;i<als.length;i++){
      var al=als[i], tm=al.querySelector('.tm'); if(!tm) continue;
      var key=al.getAttribute('data-h')||'';
      if(al._rvKey!==key){ al._rvKey=key; al._rvEnd=endFrom(tm.textContent.toLocaleUpperCase('de-DE')); }
      if(!al._rvEnd) continue;
      var left=Math.max(0,al._rvEnd-Date.now());
      var H=Math.floor(left/3600000), mm=Math.floor(left%3600000/60000), ss=Math.floor(left%60000/1000);
      var t=H>=24?('NOCH '+Math.floor(H/24)+(Math.floor(H/24)===1?' TAG':' TAGE')):((H>0?H+' STD ':'')+p(mm)+' MIN '+p(ss)+' SEK');
      if(tm.textContent!==t){ tm.textContent=t; tm.style.fontVariantNumeric='tabular-nums'; }
    }
  }
  setInterval(tick,250);
})();
